module.exports = __webpack_public_path__ + "img/软件产品-pow1.7cd52b78.png";